import React, { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import styles from "./Button.module.sass";
import { ReactComponent as LoadingIcon } from "images/load.svg";

export enum BUTTON_VARIANTS {
	CONTAINED = "contained",
	OUTLINED = "outlined",
	TEXT = "text",
}

export enum BUTTON_COLORS {
	PRIMARY = "primary",
	ERROR = "error",
}

interface ButtonPropsInterface extends React.DOMAttributes<HTMLButtonElement> {
	className?: string;
	type?: "submit" | "button" | "reset";
	variant?: BUTTON_VARIANTS;
	color?: BUTTON_COLORS;
	href?: string;
	to?: string;
	full?: boolean;
	disabled?: boolean;
	// onClick?: () => void;
	children: ReactNode;
	state?: any;
	loading?: boolean;
}

const Button: FC<ButtonPropsInterface> = ({
	className,
	type = "submit",
	variant = BUTTON_VARIANTS.CONTAINED,
	color = BUTTON_COLORS.PRIMARY,
	href,
	to,
	full,
	disabled,
	onClick,
	state,
	children,
	loading = false,
	...props
}) => {
	const classes = cn(styles.button, className, [styles[variant]], {
		[styles[`${variant}__${color}`]]: color && variant,
		[styles["full"]]: full,
		[styles["disabled"]]: disabled,
	});

	if (href) {
		return (
			<a href={href} className={classes}>
				{children}
			</a>
		);
	} else if (to) {
		return (
			<Link state={state} to={to} className={classes}>
				{children}
			</Link>
		);
	} else {
		return (
			<button
				onClick={disabled || loading ? () => {} : onClick}
				type={type}
				className={classes}
				style={{ ...(disabled && (variant === "contained" || variant === "text") && { border: "none" }) }}
				{...props}>
				{loading ? <LoadingIcon className={styles.loading} /> : children}
			</button>
		);
	}
};

export default Button;
